export default {
  provide() {
    return {
      parentvalidator: this.$validator,
      parenttouched: this.touched
    }
  },
}


// WEBPACK FOOTER //
// ./src/mixins/providesValidator.js